import { useEffect, useState } from "react";
import { Trash2, FileDown, Mail } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function NewsletterTab() {
  const [subs, setSubs] = useState([]);

  const load = () => api.get("/admin/newsletter").then((r) => setSubs(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const exportCsv = async () => {
    try {
      const res = await api.get("/admin/newsletter/export", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "newsletter-emisphere.csv";
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Export CSV téléchargé");
    } catch (e) { toast.error(errMsg(e)); }
  };

  const remove = async (id, email) => {
    if (!window.confirm(`Désinscrire ${email} ?`)) return;
    try {
      await api.delete(`/admin/newsletter/${id}`);
      toast.success("Inscription supprimée");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="grid gap-4" data-testid="newsletter-admin">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 text-sm text-slate-300">
          <Mail className="h-4 w-4 text-orange-500" />
          <span className="font-bold">{subs.length}</span> inscrit(s) à la newsletter
        </p>
        <button onClick={exportCsv} data-testid="newsletter-export-csv"
          className="flex items-center gap-2 rounded-lg border border-orange-500/40 px-4 py-2 text-xs font-bold uppercase tracking-wider text-orange-400 transition-all hover:bg-orange-500/10">
          <FileDown className="h-4 w-4" /> Exporter CSV
        </button>
      </div>
      {subs.length === 0 ? (
        <p data-testid="newsletter-empty" className="text-slate-500">
          Aucun inscrit pour le moment. Le formulaire est visible sur la page d'accueil.
        </p>
      ) : (
        <div className="grid gap-2">
          {subs.map((s) => (
            <div key={s.id} data-testid={`newsletter-row-${s.id}`}
              className="flex items-center justify-between rounded-lg border border-slate-700/60 bg-[#060B18] px-4 py-2.5">
              <span className="text-sm text-slate-200">{s.email}</span>
              <div className="flex items-center gap-3">
                <span className="text-xs text-slate-500">{new Date(s.created_at).toLocaleDateString("fr-FR")}</span>
                <button onClick={() => remove(s.id, s.email)} data-testid={`newsletter-delete-${s.id}`} aria-label={`Désinscrire ${s.email}`}
                  className="rounded-lg border border-red-500/40 p-1.5 text-red-400 transition-all hover:bg-red-500/10">
                  <Trash2 className="h-3.5 w-3.5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
